// Theme
export const CHART_DATA_THEMES = {
  LIGHT: 'light',
  DARK: 'dark',
};

// Default
export const SVG_PADDING = 50;
export const DEFAULT_CHART_CONFIGS = {
  RADIAL: 6, // Count of radial segments
  AZIMUTH: 8, // Count of longitudinal segments
  CENTER: 30, // Percentage of height
  CHART_SCALES: {
    X_MIN: 0,
    X_MAX: 40,
    Y_MIN: 0,
    Y_MAX: 80,
  },
};
export const X_AXIS = 'x_axis';
export const Y_AXIS = 'y_axis';

// SVG styles
export const STROKE_WIDTH = 1;
export const STROKE_COLOR_DARK = '#4A4C59';
export const STROKE_COLOR_LIGHT = '#CECFD9';
export const GRADIENT_COLOR_START = '#FF6F26';
export const GRADIENT_COLOR_END = '#FF66BA';
export const GRADIENT_TOTAL_ANGLE = 180;
export const DARK_THEME_BG_COLOR = '#0d0f1c';

// Chart configurations
export const MAX_OFFSET_PERCENTAGE = 50;
export const MIN_OFFSET_PERCENTAGE = 0;
export const MAX_RADIAL_SEGMENTS_COUNT = 8;
export const MIN_RADIAL_SEGMENTS_COUNT = 1;
export const MAX_ANGLE_SEGMENTS_COUNT = 20;
export const MIN_ANGLE_SEGMENTS_COUNT = 2;

// X Axis plot configurations
export const AXIS_LABEL_CONFIGS = {
  BI: 'bi',
  TRI: 'tri',
  FULL: 'full',
};

export const X_AXIS_LABEL_CONFIGS = {
  ...AXIS_LABEL_CONFIGS,
};

export const Y_AXIS_LABEL_CONFIGS = {
  ...AXIS_LABEL_CONFIGS,
};

// Label configuration count
export const LABEL_CONFIG_COUNT = {
  [X_AXIS_LABEL_CONFIGS.BI]: 1,
  [X_AXIS_LABEL_CONFIGS.TRI]: 2,
};

// Points SVG params
export const POINT_SVG_COLORS = {
  HOLLOW_COLOR: '#0D0F1C',
  BORDER_COLOR: '#293950',
  ACTIVE_COLOR: '#EBECF2',
  HOVER_COLOR: '#8694FF',
};

export const POINT_SVG_SIZES = {
  small: 4,
  medium: 6,
  large: 10,
};

export const POINT_SVG_BOUNDARY_OFFSET = {
  small: 1,
  medium: 1.5,
  large: 1.75,
};

// Animations
export const ANIMATION_BASE_DELAY = 50;
export const ANIMATION_DURATION = 800;
export const ANIMATION_DELAY = 75;
export const ANIMATION_FILL_MODE = 'forwards';
export const ANIMATION_TIMING_FUNCTION = 'ease-in-out';

// Filters
export const FILTER_CATEGORIES = ['critical', 'high', 'moderate'];
